import {
  requestUserSave,
  requestUserDelete,
  requestUserBankDelete,
  requestSendMessage,
  requestSendMessageUsers,
  requestSendMessageList,
  requestReserveMessageUsers,
  requestReseveMessageList,
  requestCancelReseveMessage,
  requestCircleAlarmToggle,
  requestCircleAlarmSend
} from "../apis/obituaryMember_api";

const state = {};
const getters = {};
const mutations = {};
const actions = {
  // 상주 저장
  async REQUEST_USER_SAVE(_, params) {
    try {
      const result = await requestUserSave(params);

      if (result) {
        return result;
      }

      return false;
    } catch (error) {
      console.error(error);
      return false;
    }
  },

  // 상주 삭제
  async REQUEST_USER_DELETE(_, params) {
    try {
      const result = await requestUserDelete(params);

      if (result) {
        return result;
      }

      return false;
    } catch (error) {
      console.error(error);
      return false;
    }
  },

  async REQUEST_USER_BANK_DELETE(_, params) {
    try {
      const result = await requestUserBankDelete(params);

      if (result) {
        return result;
      }

      return false;
    } catch (error) {
      console.error(error);
      return false;
    }
  },

  // 각종 메시지 (알림톡, 문자, 답례글 ) 보내기
  async REQUEST_SEND_MESSAGE(_, params) {
    try {
      const result = await requestSendMessage(params);

      if (result) {
        return result;
      }

      return false;
    } catch (error) {
      console.error(error);
      return false;
    }
  },

  // 상주 일괄전송 & 선택 전송
  async REQUEST_SEND_MESSAGE_USERS(_, params) {
    try {
      const result = await requestSendMessageUsers(params);

      if (result) {
        return result;
      }

      return false;
    } catch (error) {
      console.error(error);
      return false;
    }
  },

  // 메시지 전송 내역 불러오기
  async REQUEST_SEND_MSG_LIST(_, event_no) {
    try {
      const result = await requestSendMessageList(event_no);

      if (result) {
        return result;
      }

      return false;
    } catch (error) {
      console.error(error);
      return false;
    }
  },

  // 상주 예약 전송
  async REQUEST_RESERVE_MESSAGE_USERS(_, params) {
    try {
      const result = await requestReserveMessageUsers(params);

      if (result) {
        return result;
      }

      return false;
    } catch (error) {
      console.error(error);
      return false;
    }
  },

  // 메시지 예약 내역 불러오기
  async REQUEST_RESERVE_MSG_LIST(_, event_no) {
    try {
      const result = await requestReseveMessageList(event_no);

      if (result) {
        return result;
      }

      return false;
    } catch (error) {
      console.error(error);
      return false;
    }
  },

  // 예약 삭제
  async REQUEST_CANCEL_RESERVE_MESSAGE(_, params) {
    try {
      const result = await requestCancelReseveMessage(params);

      if (result) {
        return result;
      }

      return false;
    } catch (error) {
      console.error(error);
      return false;
    }
  },

  // 기일 알림 자동발송 on/off
  async REQUEST_CIRCLE_ALARM_TOGGLE(_, params) {
    try {
      const result = await requestCircleAlarmToggle(params);

      if (result) {
        return result;
      }

      return false;
    } catch (error) {
      console.error(error);
      return false;
    }
  },

  // 기일 알림 수동 발송 (특정 상주 1명)
  async REQUEST_CIRCLE_ALARM_SEND(_, params) {
    try {
      const result = await requestCircleAlarmSend(params);

      if (result) {
        return result;
      }

      return false;
    } catch (error) {
      console.error(error);
      return false;
    }
  }
};

export default { mutations, state, actions, getters };
